export default "__VITE_ASSET__DyNERZ_f__ 640w, __VITE_ASSET__hgz9161___ 768w, __VITE_ASSET__DeBcn9eD__ 896w";